import { RESET_STATE } from 'store/global/actions';

import { CONTACTS_PRESENTATION_ACTION_TYPE } from '../actions';

const initialState = [];

const contactsPresentationReducer = (state = initialState, { type, payload }) => {
  switch (type) {
    case CONTACTS_PRESENTATION_ACTION_TYPE.GET_CONTACTS:

    case CONTACTS_PRESENTATION_ACTION_TYPE.UPDATE_CONTACTS: {
      return payload;
    }

    case RESET_STATE:
      return initialState;

    default:
      return state;
  }
};

export default contactsPresentationReducer;
